import { render, staticRenderFns } from "./AmlVerificationTab.vue?vue&type=template&id=349f002e"
import script from "./AmlVerificationTab.vue?vue&type=script&lang=js"
export * from "./AmlVerificationTab.vue?vue&type=script&lang=js"
import style0 from "./AmlVerificationTab.vue?vue&type=style&index=0&id=349f002e&prod&lang=css"
import style1 from "spinkit/scss/spinkit.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports